import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import Layout from "../components/Layout";
import api from "../lib/api";
import { Card, CardContent } from "../components/ui/card";
import { Progress } from "../components/ui/progress";
import { Badge } from "../components/ui/badge";
import { ChartBar, Books, CheckCircle } from "@phosphor-icons/react";

export default function ProgressPage() {
  const { user } = useAuth();
  const [progressData, setProgressData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/progress/my").then(r => { setProgressData(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <Layout>
      <div className="p-6 md:p-8 lg:p-12" data-testid="progress-page">
        <div className="mb-8">
          <p className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-1">Learning</p>
          <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-950" style={{ fontFamily: "'Outfit', sans-serif" }}>
            My Progress
          </h1>
        </div>

        {loading ? (
          <div className="space-y-4">{[1,2,3].map(i => <div key={i} className="h-20 bg-slate-100 animate-pulse" />)}</div>
        ) : progressData.length === 0 ? (
          <div className="text-center py-16">
            <ChartBar size={48} className="text-slate-300 mx-auto mb-4" />
            <p className="text-slate-500 mb-2">No progress yet</p>
            <Link to="/programmes" className="text-sm text-blue-800 hover:underline">Browse programmes to get started</Link>
          </div>
        ) : (
          <div className="space-y-4">
            {progressData.map((p, idx) => (
              <Link key={p.course_id} to={`/courses/${p.course_id}`} data-testid={`progress-card-${idx}`}>
                <Card className="border border-slate-200 rounded-none shadow-sm hover:border-slate-400 hover:shadow-md transition-all">
                  <CardContent className="p-5">
                    <div className="flex items-center gap-4">
                      <div className="w-12 h-12 bg-blue-800/10 flex items-center justify-center flex-shrink-0">
                        {p.percentage === 100 ? <CheckCircle size={24} weight="fill" className="text-emerald-600" /> : <Books size={24} className="text-blue-800" />}
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center justify-between mb-1">
                          <h3 className="font-semibold text-slate-900 truncate" style={{ fontFamily: "'Outfit', sans-serif" }}>{p.course_title}</h3>
                          <Badge variant={p.percentage === 100 ? "default" : "secondary"} className="rounded-none text-xs ml-2">
                            {p.percentage}%
                          </Badge>
                        </div>
                        <Progress value={p.percentage} className="h-2 mb-1" />
                        <p className="text-xs text-slate-500">{p.completed_lessons} of {p.total_lessons} lessons completed</p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
